export const QUERY_KEYS = {
    transactions: 'transactions',
    guest_gifting_transactions: 'guest-gifting-transactions',
    goals_detailed_transactions: 'goals-detailed-transactions',
    current_transaction: 'current-transaction',
    check_transaction_status: 'check-transaction-status'
}
